exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#formrun[data-v-10215d12]{position:absolute;left:-9999px;top:-9999px;z-index:-1}._formrun_gotcha[data-v-10215d12]{height:1px;width:1px;overflow:hidden}.spinnerWrapper[data-v-10215d12]{width:100vw;height:calc(100vh - 100px)}", ""]);

// exports
